var unitPrice = "{{ pricePerUnit }} per stuk";
var unitsCount = "{{ unitsCount }} eenheden";
var unitCount = "{{ unitsCount }} eenheid";
var unitPriceWithQuantity = "{{ pricePerUnit }} per stuk / {{ unitsCount }} eenheden";
var vatInclusive = "Incl. btw";
var vatExclusive = "Excl. btw";
var excludeShipping = "Excl. {{ shipping }}";
var includeShipping = "Incl. {{ shipping }}";
var shipping = "verzending";
var vatAndShipping = {
	includeVatExcludeShipping: "Incl. btw, excl. {{ shipping }}",
	excludeVatIncludeShipping: "Excl. btw, incl. {{ shipping }}",
	includeVatIncludeShipping: "Incl. btw, incl. {{ shipping }}",
	excludeVatExcludeShipping: "Excl. btw, excl. {{ shipping }}"
};
var priceSummary = "Prijsoverzicht";
var priceSummaryInfoIcon = "Info-icoontje voor prijssamenvatting";
var priceSummaryModal = "Dialoogvenster voor prijssamenvatting";
var priceSummaryCloseModal = "Dialoogvenster voor prijssamenvatting sluiten";
var priceSummaryTermsAndConditions = "*Voor elke bestelling wordt een unieke film of drukplaat gemaakt en wordt apparatuur speciaal afgesteld om jouw ontwerp te drukken. ";
var priceSummaryBasePrice = "Basisprijs";
var priceSummarySetupFee = "Opzetkosten*";
var priceSummarySubtotal = "Subtotaal";
var differentialPrice = {
	included: "Inbegrepen",
	forUnits: "{{ differentialPrice }} voor {{ quantity }} stuks",
	forUnit: "{{ differentialPrice }} voor {{ quantity }} stuk"
};
var priceFrom = "Van {{ price }}";
var priceFromEach = "Van {{ price }} per stuk";
var volumeDiscount = "{{volumeDiscount}}% kwantumkorting";
var volumeDiscountPlusSale = "{{volumeDiscount}}% kwantumkorting + sale";
var rangePrice = "{{xx}} - {{yy}}";
var unitRangePrice = "{{rangePrice}} per stuk";
var originalPrice = "oorspronkelijke prijs:";
var salePrice = "huidige aanbiedingsprijs:";
var setupFee = "{{ setupFee }} opzetkosten zijn van toepassing";
var noSetupFee = "Geen opzetkosten";
var vatAndSetupFee = {
	noVatInclSetup: "Incl. {{ setupFee }} opzetkosten",
	inclVatAndSetup: "Incl. {{ setupFee }} opzetkosten en btw",
	exclVatInclSetup: "Incl. {{ setupFee }} opzetkosten. excl. btw",
	inclVatSetupInclShipping: "Incl. {{ setupFee }} opzetkosten en btw, incl. {{ shipping }}",
	inclVatSetupExclShipping: "Incl. {{ setupFee }} opzetkosten en btw, excl. {{ shipping }}",
	exclVatSetupInclShipping: "Incl. {{ setupFee }} opzetkosten, excl. btw, incl. {{ shipping }}",
	exclVatSetupExclShipping: "Incl. {{ setupFee }} opzetkosten, excl. btw en {{ shipping }}"
};
var priceFor = "{{ quantity }} voor {{ price }}";
var nlnl = {
	unitPrice: unitPrice,
	unitsCount: unitsCount,
	unitCount: unitCount,
	unitPriceWithQuantity: unitPriceWithQuantity,
	vatInclusive: vatInclusive,
	vatExclusive: vatExclusive,
	excludeShipping: excludeShipping,
	includeShipping: includeShipping,
	shipping: shipping,
	vatAndShipping: vatAndShipping,
	priceSummary: priceSummary,
	priceSummaryInfoIcon: priceSummaryInfoIcon,
	priceSummaryModal: priceSummaryModal,
	priceSummaryCloseModal: priceSummaryCloseModal,
	priceSummaryTermsAndConditions: priceSummaryTermsAndConditions,
	priceSummaryBasePrice: priceSummaryBasePrice,
	priceSummarySetupFee: priceSummarySetupFee,
	priceSummarySubtotal: priceSummarySubtotal,
	differentialPrice: differentialPrice,
	priceFrom: priceFrom,
	priceFromEach: priceFromEach,
	volumeDiscount: volumeDiscount,
	volumeDiscountPlusSale: volumeDiscountPlusSale,
	rangePrice: rangePrice,
	unitRangePrice: unitRangePrice,
	originalPrice: originalPrice,
	salePrice: salePrice,
	setupFee: setupFee,
	noSetupFee: noSetupFee,
	vatAndSetupFee: vatAndSetupFee,
	priceFor: priceFor
};

export { nlnl as default, differentialPrice, excludeShipping, includeShipping, noSetupFee, originalPrice, priceFor, priceFrom, priceFromEach, priceSummary, priceSummaryBasePrice, priceSummaryCloseModal, priceSummaryInfoIcon, priceSummaryModal, priceSummarySetupFee, priceSummarySubtotal, priceSummaryTermsAndConditions, rangePrice, salePrice, setupFee, shipping, unitCount, unitPrice, unitPriceWithQuantity, unitRangePrice, unitsCount, vatAndSetupFee, vatAndShipping, vatExclusive, vatInclusive, volumeDiscount, volumeDiscountPlusSale };
